import type { FaireThemeEntity } from "../../entity_types/theme";

export const board_demo_r_9rhufegspe_hero_mothers_day: FaireThemeEntity = {
  token: "board_demo_r_9rhufegspe_hero_mothers_day",
  type: "theme",
  retailerToken: "r_9rhufegspe",
  name: "Mother's Day picks",
  description:
    "Twenty-eight picks curated for your Jersey City boho-home-and-gift boutique. Expect women-owned keepsake jewelry with a message, small-batch self-care kits, and pressed-floral statement pieces that sit alongside your Mother's Day table and stay relevant on your shelves after the holiday.",
  bgColor: "#F5D4E8",
  productTokens: [
    "p_h297mzz26z",
    "p_typpjyctcu",
    "p_f9my9ks3re",
    "p_8gaxqab3q5",
    "p_j3r3rxkxuq",
    "p_2mgspra5zw",
    "p_34d7kt6smr",
    "p_cgjdjphzzz",
    "p_8eb4uhzb88",
    "p_uvh67nvdzd",
    "p_e3d88bzqhj",
    "p_4jgmwqrkmx",
    "p_phq9tx8p59",
    "p_jjvs5qsqym",
    "p_rrzvrx4p4z",
    "p_ee5hab34v9",
    "p_m82nebswmp",
    "p_1ib4ie8e",
    "p_gd72vfu7ny",
    "p_8hvty77kwp",
    "p_nbrbqc7gwb",
    "p_qqb4p8nt2x",
    "p_8szcjg6psh",
    "p_a7h3l3du21",
    "p_6apftqxccs",
    "p_8auuhgvbzn",
    "p_wsuc2pf6zj",
    "p_tpvvg4agbp",
  ],
  coverImageUrl:
    "https://cdn.faire.com/fastly/efd4664aecfb89006208301a8bc1e7930e536727d9f96ef4dc720482773e1815.jpeg",
  thumbnailImageUrls: [
    "https://cdn.faire.com/fastly/efd4664aecfb89006208301a8bc1e7930e536727d9f96ef4dc720482773e1815.jpeg",
    "https://cdn.faire.com/fastly/3c501d7ac03773c1217cce8b7bf2cb7ec7517a7f9704bf55932a4f419286dc5d.jpeg",
    "https://cdn.faire.com/fastly/aba69874d8a7d8ddad1b9e97be84ddcb6125c4f264a47c65989ce3059244878c.jpeg",
    "https://cdn.faire.com/fastly/3fc7de40053e8c5173787e8923b15b6e19fe5d03c01552027349b239b8a65a26.jpeg",
    "https://cdn.faire.com/fastly/45d76dca0f27bd358ed71641ac3fca958c494645729585be4bab73dd78b23063.jpeg",
    "https://cdn.faire.com/fastly/17f8f72706753cd3f4c41c5aeea900f1bc34346b56f53413d48b571c1262067f.jpeg",
  ],
  itemCount: 28,
  source: "curated_md_hero",
  teaser: "mothers-day-picks",
  meta: {
    source: "mock",
    importedAt: "2026-04-19T23:00:00.000Z",
    importedBy: "board-demo-canonicalize",
  },
};
